import { Stack, useLocalSearchParams } from 'expo-router';
import { ScrollView } from 'react-native';

import { InstagramConnection } from '@/components/integrations/instagram-connection';
import { PageHeaderRow } from '@/components/page-header-row';
import { Text } from '@sixam/ui/text';

export default function UserInstagramIntegrationScreen() {
  const { connected, error } = useLocalSearchParams<{
    connected?: string;
    error?: string;
  }>();

  return (
    <>
      <Stack.Screen options={{ headerShown: process.env.EXPO_OS !== 'web', title: 'Instagram' }} />
      <Stack.Screen.BackButton displayMode="minimal">Integrations</Stack.Screen.BackButton>
      <ScrollView
        contentInsetAdjustmentBehavior="automatic"
        className="flex-1 bg-background"
        contentContainerClassName="gap-4 p-6"
      >
        <PageHeaderRow
          backHref="/app/settings/integrations"
          subtitle="Your account"
          title="Instagram"
        />
        {process.env.EXPO_OS !== 'web' ? <Text variant="muted">Your account</Text> : null}

        <InstagramConnection
          description="Link your personal Instagram professional account (Business or Creator) to show your profile on 6am."
          returnPath="/app/integrations/instagram"
          connected={connected}
          error={error}
        />
      </ScrollView>
    </>
  );
}
